import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApiClient } from "../../contexts/ApiClientContext";
import SETTINGS from "../../globals";
import AppSections from "../../utils/AppSections";
import AppSubSections from "../../utils/AppSubSections";
import ButtonInfo from "../common/button/ButtonInfo";
import AppIcons from "../../utils/AppIcons";
import Loading from "../common/Loading";
import ConditionReport from "../../model/ConditionReport";
import Button from "../common/button/Button";
import ButtonAction from "../common/button/ButtonAction";
import ButtonType from "../common/button/ButtonType";
import DocumentState from "../../model/enums/DocumentState";

interface IConditionReportsListElementProps {
  data: ConditionReport;
  canEdit: boolean;
  navigable: boolean;
  itemSelectionMode: boolean;
  selected?: boolean;
  onClick?: () => void;
}

function ConditionReportsListElement({
  data,
  canEdit,
  itemSelectionMode,
  selected = false,
  onClick,
}: IConditionReportsListElementProps) {
  // reference to the navigator
  const navigate = useNavigate();
  // reference to the ApiClient instance
  const apiClient = useApiClient();
  // manage data loading animation
  const [loading, setLoading] = useState(true);

  // load record data from the server
  useEffect(() => {
    //get the data to display
    setLoading(false);
  }, [apiClient, selected]);

  if (loading) {
    return <Loading />;
  }

  const handleDownloadReport = async () => {
    console.log(data.id!);

    try {
      window.location.href =
        SETTINGS.API_ROOT + `/conditionreports/${data.id}/download`;
    } catch (error: any) {
      if (!error.processed) {
        console.log(error);
      }
    }
  };

  return (
    <div
      onClick={onClick}
      // className="p-4 w-full border border-solid border-gray-200 rounded-xl mt-3 mb-5 text-gray-600 hover:bg-blue-50 cursor-pointer"
      className={`p-4 w-full border border-solid border-gray-200 rounded-xl mt-3 mb-5 text-gray-600 cursor-pointer hover:bg-green-200 ${
        selected ? "bg-green-300" : "bg-white"
      }`}
    >
      <div className="flex flex-col flex-wrap">
        <div className="flex flex-col flex-wrap items-start">
          <div className="flex flex-row justify-between w-full mr-0 pr-0 relative">
            <h1 className="text-xl font-bold mb-2 mt-0">{data.name}</h1>
          </div>
          <p className="text-gray-700 text-md mb-1 mt-3">
            {" "}
            Status: {data.status}
          </p>
          <p className="text-gray-700 text-md mb-4">
            Survey date:{" "}
            {new Intl.DateTimeFormat("en-GB")
              .format(new Date(data.survey_date!!))
              .replaceAll("/", ".")}
          </p>
        </div>
        <div className="grid grid-cols-1 text-sm mt-4 w-full text-gray-700">
          <ButtonInfo>
            {AppIcons.CLOCK}
            Created:{" "}
            {new Intl.DateTimeFormat("en-GB")
              .format(new Date(data.created_on!!))
              .replaceAll("/", ".")}
          </ButtonInfo>
        </div>
        <div className="flex w-full flex-row justify-between mt-4">
          {itemSelectionMode === false &&
            data.status !== DocumentState.public &&
            canEdit && (
              <Button
                purpose={ButtonAction.EDIT}
                type={ButtonType.ICON_TEXT}
                label="Edit"
                className="ml-0"
                onClick={() =>
                  navigate(
                    SETTINGS.get_path({
                      section: AppSections.E3DS,
                      id: data.id_e3dmodel,
                      additionalSections: [
                        AppSections.CONDITION_REPORTS,
                        data.id?.toString() ?? "",
                      ],
                      subsection: AppSubSections.EDIT,
                    }),
                  )
                }
              />
            )}
          <Button
            purpose={ButtonAction.DOWNLOAD}
            type={ButtonType.ICON_TEXT}
            label="Download"
            className="ml-0"
            onClick={handleDownloadReport}
          />
        </div>
      </div>
    </div>
  );
}

export default ConditionReportsListElement;
